import * as React from 'react';

import type {OutcomeType} from 'nutshell-graphql-types';
import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {ClosedLeadAccountAssignmentAutomationCard} from '../cards/closed-lead-account-assignment-automation-card';

import {StageSingleItemContainer} from './stage-single-item-container';

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
    outcomeType: OutcomeType;
};

const defaultAutomations = {accountTypeAutomations: []} as const;

export function ClosedLeadAccountAssignmentAutomation(props: Props) {
    const automations =
        props.closedLeadAutomations.find(
            (automation) => automation.outcomeType === props.outcomeType
        ) || defaultAutomations;

    const accountAssignmentCard = automations.accountTypeAutomations.length ? (
        <ClosedLeadAccountAssignmentAutomationCard
            index={0}
            isDraggable={false}
            parentId={props.outcomeType}
            // @ts-expect-error
            accountTypeAutomation={automations.accountTypeAutomations[0]}
        />
    ) : undefined;

    return (
        <StageSingleItemContainer
            type='closedLeadAccountTypeAutomations'
            isCardBeingDragged={false}
            isLoading={props.isLoading}
            errorMessage={props.errorMessage}
            hideAddCard={Boolean(automations.accountTypeAutomations.length)}
            parentId={props.outcomeType}
            item={accountAssignmentCard}
        />
    );
}
